import BaseHeading from "../baseComponents/baseHeading.js";
import BaseParagraph from "../baseComponents/baseParagraph.js";
import BaseImage from "../baseComponents/baseImage.js";
import BarcodeComponent from "./BarcodeComponent.js";
import useColors from "../customHooks/useColors.js";
import { useSelector } from "react-redux";

const Reward = ({
  name,
  description,
  image = null,
  barcode,
  discountText = null,
  validUntil = null,
}) => {
  const [currentColors] = useColors();

  return (
    <span
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          backgroundColor: currentColors.septenary,
          borderBottom: "1px solid rgba(0,0,0,0.3)",
        }}
      >
        <BaseImage style={{ width: "50%" }} src={image} />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          backgroundColor: currentColors.septenary,
        }}
      >
        <BaseParagraph
          translate={false}
          style={{
            alignSelf: "flex-end",
            backgroundColor: currentColors.primary,
            color: currentColors.secondary,
            padding: "7px",
            position: "relative",
            transform: "translateY(-50%)",
          }}
        >
          {discountText}
        </BaseParagraph>
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            marginRight: "7px",
            transform: "translateY(-50%)",
          }}
        >
          <BaseParagraph style={{}}>validUntil</BaseParagraph>
          <span>&nbsp;</span>
          <BaseParagraph translate={false} style={{}}>
            {validUntil}
          </BaseParagraph>
        </div>
        <span
          style={{
            padding: "1.5em",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <BaseHeading>{name}</BaseHeading>
          <br />
          <BaseParagraph>{description}</BaseParagraph>
        </span>
        <BarcodeComponent
          background={currentColors.septenary}
          code={barcode}
          height={60}
        />
        <br />
      </div>
    </span>
  );
};

export default Reward;
